import React from 'react';
import styled from '@emotion/styled';
import { spacing } from '@naf/theme';
import { ArticleBlockContentGridCol } from './ArticleBlockContentGridCol';
import { ProsAndCons as ProsAndConsComponent } from '../../../../bilguide/ProsAndCons';
import { ProsAndCons } from '../../../../../../../types/carModelType';
import { BlockContentContext } from '../../../BlockContent.utils';

interface ProsAndConsSerializerProps {
  value: ProsAndCons;
}

export const ProsAndConsBlock: React.FC<ProsAndConsSerializerProps> = ({ value }) => {
  if (!value) return null;

  const { pros, cons } = value;

  return (
    <StyledProsAndConsBlock>
      <ProsAndConsComponent pros={pros} cons={cons} />
    </StyledProsAndConsBlock>
  );
};

export const ProsAndConsSerializer = (context: BlockContentContext = BlockContentContext.Stripped) => {
  if (context === BlockContentContext.Article) {
    return ({ value }: ProsAndConsSerializerProps) => (
      <ArticleBlockContentGridCol className="pros-cons">
        <ProsAndConsBlock value={value} />
      </ArticleBlockContentGridCol>
    );
  }

  return ({ value }: ProsAndConsSerializerProps) => <ProsAndConsBlock value={value} />;
};

const StyledProsAndConsBlock = styled.div`
  margin: ${spacing.space32} 0;
`;
